import { jsx } from "react/jsx-runtime";
import { TextField } from "@mui/material";
import { HexInputAdornment } from "./components/HexInputAdornment.js";
import { useHexInput } from "./hooks/useHexInput.js";
function HexInput() {
  const { onClick, onTextChange, showCopied, textFieldValue, value, readonly, onBlur } = useHexInput();
  return /* @__PURE__ */ jsx(
    TextField,
    {
      "data-testid": "TidalColorPickerHexInput",
      fullWidth: true,
      onBlur,
      onChange: onTextChange,
      slotProps: {
        input: {
          readOnly: readonly,
          startAdornment: /* @__PURE__ */ jsx(HexInputAdornment, { color: value, onClick, showCopied })
        }
      },
      value: textFieldValue
    }
  );
}
export {
  HexInput
};
//# sourceMappingURL=HexInput.js.map
